import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TasksComponent } from './component/tasks.component';
import { SelectDocumentDialogComponent } from './component/task-details/select-document-dialog.component';

import { MaterialModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    CommonTranslationModule,
    DictionaryModule,
    ApplicationClientCommonModule
  ],
  declarations: [TasksComponent, SelectDocumentDialogComponent]

})
export class TasksModule {

}

